import React from 'react'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#202020"
        fillOpacity="0.5"
        d="M10.667 6v1.333H7.333v9.334h9.334v-3.334H18v4a.666.666 0 01-.667.667H6.667A.666.666 0 016 17.333V6.667A.667.667 0 016.667 6h4zm5.057 1.333h-3.057V6H18v5.333h-1.333V8.276L12 12.943 11.057 12l4.667-4.667z"
      ></path>
    </svg>
  )
}

export default Icon
